module.exports = new __parcel__URL__("error-general.2820089d.svg").toString();